export const TEMP_CLERK_LEVEL = 0
export const DISTRICT_MANAGER_LEVEL = 3
export const SUPER_USER_LEVEL = 4
